module.exports = ":host {\n  text-align: right;\n  font-size: smaller;\n}\n\n#my-account {\n  border-right: 1px solid gray\n}\n\nspan {\n  display: inline-block;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\nspan a {\n  color: gray\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-session/user-session.component.css
// module id = ./src/app/user-session/user-session.component.css
// module chunks = main